// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"300":"3ef988a935b2b221","563":"24b37456994eef2d"}[chunkId] + ".js";
};